// import Loadable from "app/components/Loadable";
import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FarmerList = Loadable(lazy(() => import("./FarmerList")));
const FarmerForm = Loadable(lazy(() => import("./FarmerForm")));

const farmerRoutes = [
  {
    path: "/Farmer/FarmerList",
    element: <FarmerList />,
  },
  {
    path: "/Farmer/FarmerForm",
    element: <FarmerForm />,
  },
  {
    path: "/Farmer/FarmerForm/:farmerId",
    element: <FarmerForm />,
  },
];
export default farmerRoutes;
